import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { handleFilter, handleFiltersCarList } from '../../utils/helpers';
import { apiCarGearboxId } from "../../utils/staticData";

export const mapStateToProps = state => ({
    phrase: state.filterReducer.searchField,
    groupFilter: state.filterReducer.group,
    brandFilter: state.filterReducer.brand,
    modelFilter: state.filterReducer.model,
    gprsFilter: state.filterReducer.gprs,
    fuelTypeFilter: state.filterReducer.fuelType,
    inServiceFilter: state.filterReducer.inService,
    gearboxFilter: state.filterReducer.gearbox,
    showArchivedFilter: state.filterReducer.showArchived,
    showNotArchivedFilter: state.filterReducer.showNotArchived
});

const withFilters = (WrappedComponent, omitGearboxFilter = false,
                     omitInServiceFilter = false, omitShowArchivedFilter = false,
                     omitShowNotArchivedFilter = false) => {
    const WithFilters = ({phrase, cars, groupFilter, brandFilter, modelFilter, fuelTypeFilter, gearboxFilter, gprsFilter,
                    inServiceFilter, showArchivedFilter, showNotArchivedFilter, ...props }) => {
        const [filteredCars, setFilteredCars] = useState([]);

        useEffect(() => {
            //let filtered = handleFilters(cars, groupFilter, brandFilter, modelFilter, fuelTypeFilter);
            let filtered = handleFiltersCarList(cars, groupFilter, brandFilter, modelFilter, fuelTypeFilter, gprsFilter, phrase);
            if(!omitGearboxFilter)
                filtered = handleFilter(filtered, gearboxFilter, apiCarGearboxId);
            if (inServiceFilter && !omitInServiceFilter)
                filtered = filtered.filter(car => car.serwis === inServiceFilter);
            if (!showArchivedFilter && !omitShowArchivedFilter)
                filtered = filtered.filter(car => car.zarchiwizowane === false);
            if (!showNotArchivedFilter && !omitShowNotArchivedFilter)
                filtered = filtered.filter(car => car.zarchiwizowane === true);
            setFilteredCars(filtered);
        }, [cars, groupFilter, brandFilter, modelFilter, fuelTypeFilter, gearboxFilter, inServiceFilter, showArchivedFilter, showNotArchivedFilter, phrase, gprsFilter]);

        return (
            <WrappedComponent cars={filteredCars} {...props} />
        );
    };

    WithFilters.propTypes = {
        cars: PropTypes.array,
        phrase: PropTypes.string,
        groupFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        brandFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        modelFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        fuelTypeFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        gprsFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        gearboxFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        showArchivedFilter: PropTypes.bool,
        showNotArchivedFilter: PropTypes.bool,
        inServiceFilter: PropTypes.bool,
    };

    WithFilters.defaultProps = {
        cars: []
    };
    return WithFilters;
};

export default (WrapperComponent, omitGearboxFilter, omitInServiceFilter, omitShowArchivedFilter, omitShowNotArchivedFilter) =>
    connect(
        mapStateToProps, null
    )(withFilters(WrapperComponent, omitGearboxFilter, omitInServiceFilter, omitShowArchivedFilter, omitShowNotArchivedFilter));
